import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';
import { COLORS } from '../../styles/variables';
import { device } from '../../styles/devices';

export const SkeletonCard = styled.div`
  width: 357px;
  height: 566px;
  background: ${COLORS.white};
  padding: 28px 24px 26px 24px;
  div {
    height: 100%;
  }

  @media ${device.laptop} {
    width: 424px;
  }
`;

export const SkeletonWrapper = styled.p`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: space-between;
  height: 100%;
  .status {
    height: 24px;
    width: 243px;
  }
  .name {
    height: 68px;
    width: 300px;
  }
  .location {
    height: 24px;
    width: 243px;
  }
  .image {
    height: 236px;
    width: 300px;
  }
  .price {
    height: 68px;
    width: 300px;
  }

  @media ${device.laptop} {
    .name {
      width: 375px;
    }
    .image {
      width: 375px;
    }
  }
`;

export const SkeletonLoad = styled(Skeleton)``;
